import { ShareData } from './../share-data/share-data';
import { Connectivity } from './../connectivity/connectivity';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import 'rxjs/add/operator/timeout';
import 'rxjs/add/operator/debounceTime';
//let apiUrl = 'http://localhost/wallapi/';
let apiUrl = 'https://rest.thewallscript.com/wallapi/';
@Injectable()
export class AuthService {
  constructor(public http: HttpClient, public connectivity: Connectivity, public shareData: ShareData) {}

  postData(postData, serviceName) {
    return new Promise((resolve, reject) => {
      let headers = new HttpHeaders();
      const options = { headers: headers, withCredentials: false };
      //headers.append('Content-Type', 'application/text');
      this.http
        .post(apiUrl + serviceName, JSON.stringify(postData), options)
        .debounceTime(400)
        .timeout(20000)
        .subscribe(
          res => {
            //resolve({error:false, status: 200, payload: res});
            resolve(res);
          },
          err => {
            resolve({ error: true, status: err.status, payload: err.message });
          }
        );
    }).catch(function() {});
  }



  public async authPostData(uid, token, postData, serviceName) {
    if (await this.connectivity.isOnline()) {
      postData.uid = uid;
      postData.token = token;
      return await this.postData(postData, serviceName);
    } else {
      this.shareData.changeNoInternetStatus(true);
      return Promise.reject(null);
    }
  }
}



// WEBPACK FOOTER //
// ./src/providers/auth-service/auth-service.ts